module.exports = __webpack_public_path__ + "static/media/tunnel_open.66cec508.png";